import React, { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const IconTwitter = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 20 20"
        data-fill-none
      >
        <circle
          cx="10"
          cy="10"
          r="10"
        />
        <path
          d="M17 5.65913C16.4794 5.8875 15.9246 6.03887 15.3462 6.11237C15.9412 5.75712 16.3954 5.19887 16.6089 4.526C16.0541 4.85675 15.4416 5.09038 14.7889 5.22075C14.2621 4.65988 13.5114 4.3125 12.6924 4.3125C11.1034 4.3125 9.82412 5.60225 9.82412 7.18338C9.82412 7.41088 9.84337 7.62962 9.89062 7.83787C7.5045 7.7215 5.39313 6.57788 3.97475 4.83575C3.72712 5.26538 3.58188 5.75713 3.58188 6.2865C3.58188 7.2805 4.09375 8.16162 4.85675 8.67175C4.39562 8.663 3.94325 8.52913 3.56 8.31825C3.56 8.327 3.56 8.33837 3.56 8.34975C3.56 9.7445 4.55487 10.903 5.8595 11.1699C5.62587 11.2337 5.37125 11.2644 5.107 11.2644C4.92325 11.2644 4.73775 11.2539 4.56362 11.2154C4.9355 12.352 5.99075 13.1876 7.2455 13.2147C6.269 13.9786 5.02913 14.4389 3.68688 14.4389C3.4515 14.4389 3.22575 14.4284 3 14.3995C4.27137 15.2194 5.77813 15.6875 7.403 15.6875C12.6845 15.6875 15.572 11.3125 15.572 7.52025C15.572 7.39337 15.5676 7.27088 15.5615 7.14925C16.1311 6.745 16.6097 6.24013 17 5.65913Z"
          fill="#03A9F4"
        />
      </SvgIcon>
    );
  })
);
